/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Train_Card_TitleInputs */

const en_portal_step_train_card_title = /** @type {(inputs: Portal_Step_Train_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day A · legs`)
};

const pl_portal_step_train_card_title = /** @type {(inputs: Portal_Step_Train_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień A · nogi`)
};

/**
* | output |
* | --- |
* | "Day A · legs" |
*
* @param {Portal_Step_Train_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_train_card_title = /** @type {((inputs?: Portal_Step_Train_Card_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Train_Card_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_train_card_title(inputs)
	return en_portal_step_train_card_title(inputs)
});